<script lang="ts" setup>
import { ref } from 'vue';

defineOptions({
  name: 'OpenImage',
});

const {
  src = '',
  imgClass = '',
} = defineProps<{
  src?: string;
  imgClass?: string | string[] | Record<string, any>;
}>();

const visible = ref(false);
</script>

<template>
  <div class="open-image">
    <img :data-src="src" class="lozad cursor-pointer" :key="src" :class="imgClass" @click="visible = true" v-if="src">
    <AImagePreview :src="src" v-model:visible="visible" />
  </div>
</template>

<style lang="scss" scoped>
</style>
